import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Map, Marker, InfoWindow, GoogleApiWrapper, Polyline } from 'google-maps-react';
import { withRouter } from 'react-router-dom';
// import policeIcon from '../../../../resources/icons/policeman2.png';
// import './styles/style.scss';

class InfoWindowEx extends Component {
    constructor(props) {
        super(props);
        this.infoWindowRef = React.createRef();
        this.contentElement = document.createElement('div');
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.children !== prevProps.children) {
            ReactDOM.render(
                React.Children.only(this.props.children),
                this.contentElement
            );
            this.infoWindowRef.current.infowindow.setContent(this.contentElement);
        }
    }

    render() {
        return <InfoWindow ref={this.infoWindowRef} {...this.props} />;
    }
}

export class MapShipment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Size: props.heidIcon ? props.heidIcon : 45,
            activeMarker: {},
            dataRecieve: props.dataDrawer,
            tags: '',
            dataOptions: props.dataOptions ? props.dataOptions : {},
            markerInfo: {},
            polyline: props.polyline ? props.polyline : [],
            marker: props.marker,
            type: props.type,
            showingInfoWindow: false,
            showDrawerInfo: false
        };
        this.buttonRef = React.createRef();
    }


    componentDidMount = () => {
        this.setState({
            marker: this.props.marker
        });
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            polyline: nextProps.polyline,
            marker: nextProps.marker,
        }, () => { this.buildTags() })
    }


    buildTags = () => {
        let { marker, polyline } = this.state;
        let tags = [];
        marker.map((e) => {
            tags.push(
                <Marker
                    key={e.key}
                    title={e.title}
                    name={e.name}
                    info={e}
                    data={e.data}
                    position={e.position}
                    polyline={polyline}
                    icon={{
                        url: e.icon.url,
                        anchor: new window.google.maps.Point(e.anchor ? e.anchor : 15, e.amchor ? e.anchor : 15),///***************PARA AJUTAR EL POLYLINE */
                        scaledSize: new window.google.maps.Size(this.state.Size, this.state.Size)
                    }}
                />
            );
            return e;
        });
        this.setState({
            tags
        });
    }



    render() {
        let { markerInfo, showingInfoWindow, polyline } = this.state;

        return (
            <div style={{
                position: "relative",
                height: "400px"
            }}>
                <Map google={this.props.google} zoom={this.props.zoom ? this.props.zoom : 2}
                    initialCenter={this.props.position ? this.props.position : {
                        lat: 4.0000000,
                        lng: -72.0000000
                    }}
                    styles={[
                        {
                            featureType: "water",
                            elementType: "geometry",
                            stylers: [{ color: "#8AB4F9" }],
                        },
                        {
                            featureType: "water",
                            elementType: "labels.text.stroke",
                            stylers: [{ color: "#8AB4F9" }],
                        },
                    ]}>
                    {this.state.tags}
                    <InfoWindowEx visible={showingInfoWindow} onClose={this.onInfoWindowClose} marker={markerInfo}>
                        <div style={{ minWidth: 250 }}>
                        </div>
                    </InfoWindowEx>
                    <Polyline
                        path={polyline}
                        geodesic={true}
                        strokeColor='#FF0000'
                        strokeOpacity={1.0}
                        strokeWeight={2}
                    />
                </Map>
                {/* <div
                        style={{
                            position: "relative",
                            height: "400px"
                        }}>
                        {this.state.map}
                    </div> */}
            </div>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: 'AIzaSyAl_10ZKSqnrviAV-KSQ6c8i4Sa_gEhEmA',
    v: '3.30'
})(withRouter(MapShipment));
